import { RefCallback, useCallback, useEffect, useState } from 'react';

export function useScrollIntoView<TElement extends HTMLElement = HTMLElement>() {
  const [node, setNode] = useState<TElement | null>(null);

  const refCallback: RefCallback<TElement> = useCallback((refNode) => {
    setNode(refNode);
  }, []);

  useEffect(() => {
    if (node) {
      node.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [node]);

  return refCallback;
}
